import { createReducer } from '@/redux/root';
import {
  nameSpace,
  pushToAspynAsync,
  clearAspynResultAction,
  requestMigrationJobsAsync,
  getPatAsync,
  updatePatAsync,
  removePatAsync,
} from './actions';
import { logoutAction } from '@/redux/auth';

const initialState = {
  aspynResult: null,
  migrationJobs: {
    data: [],
    meta: null,
  },
  pat: null,
};

export const aspynMigratorReducer = createReducer(nameSpace, initialState, {
  [pushToAspynAsync.success]: ({ state, action: { payload } }) => {
    state.aspynResult = payload.data.report;
  },

  [pushToAspynAsync.failure]: ({ state, action: { payload } }) => {
    // Store error response in a format compatible with the modal (as array)
    state.aspynResult = {
      error: 'An error occurred while pushing to Aspyn',
      details: {
        message: payload?.response?.data?.errors?.[0]?.detail || 'Unknown error occurred while pushing to Aspyn. Please try again later. If the problem persists, contact the system administrator.',
      },
    };
  },

  [clearAspynResultAction]: ({ state }) => {
    state.aspynResult = null;
  },

  [requestMigrationJobsAsync.success]: ({ state, action: { payload } }) => {
    state.migrationJobs = {
      data: payload.data || [],
      meta: payload.meta || null,
    };
  },

  [requestMigrationJobsAsync.failure]: ({ state }) => {
    state.migrationJobs = {
      data: [],
      meta: null,
    };
  },

  [getPatAsync.success]: ({ state, action: { payload } }) => {
    state.pat = payload.pat ? {
      token: payload.pat,
      expiresAt: payload.expires_at,
    } : initialState.pat;
  },

  [getPatAsync.failure]: ({ state }) => {
    state.pat = initialState.pat;
  },

  [updatePatAsync.success]: ({ state, action: { payload } }) => {
    state.pat = payload.pat ? {
      token: payload.pat,
      expiresAt: payload.expires_at,
    } : initialState.pat;
  },

  [removePatAsync.success]: ({ state }) => {
    state.pat = initialState.pat;
  },

  [logoutAction]: ({ state }) => {
    state.aspynResult = null;
    state.migrationJobs = {
      data: [],
      meta: null,
    };
    state.pat = null;
  },
});
